<template>
  <div id="player-general-performance-table">
    <v-data-table
      :headers="tableHeaders"
      :loading="loading"
      :items="players"
      hide-default-footer
      dense
      disable-pagination
      sort-by="last_name"
    >
      <!--<editor-fold desc="ITEM SLOT">-->
      <template v-slot:item="{ item }">
        <tr
          class="clickable"
          @click="$emit('select:player', item)"
        >
          <td class="text-no-wrap">
            {{ item.last_name }}, {{ item.first_name }}
          </td>
          <td
            v-for="variable in tableHeaders.slice(1)"
            :key="variable.id"
          >
            <table-bar-value
              :value="item.latest_stats[variable.value + '_' + interval]"
              :max="maxValues[variable.value + '_' + interval]"
              color="grey lighten-2"
            >
              {{ item.latest_stats[variable.value + '_' + interval] }}
            </table-bar-value>
          </td>
        </tr>
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="LOADING SLOT">-->
      <template slot="loading">
        <div
          class="pa-5 d-flex justify-center align-center"
          :style="'min-height: ' + (players.length * 49)+'px'"
        >
          <v-progress-circular
            indeterminate
            size="48"
            width="4"
            color="grey lighten-2"
          />
        </div>
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="PROGRESS SLOT">-->
      <template slot="progress">
        <!-- override default progress bar -->
        <div />
      </template>
      <!--</editor-fold>-->
    </v-data-table>
  </div>
</template>

<script>

import TableBarValue from '@/components/helpers/TableBarValue'
import { getColorForValue } from '@/utils/helpers'

export default {
  name: 'TrainingLoadHeartRateTable',
  components: { TableBarValue },
  props: {
    players: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    maxValues: {
      type: Object,
      required: true
    },
    interval: {
      type: String,
      default: '1'
    },
    tableHeaders: {
      type: Array,
      required: true
    }
  },
  data: () => ({
  }),
  computed: {
  },
  methods: {
    getColorFromValue(value, max) {
      return getColorForValue(value, max)
    }
  }
}
</script>
